import styled from "styled-components";
import { backdropBlurFilter } from "../../../../utils/backdropblur";
const sizeMap = () => ({
    small: {
        l: "1 100%",
    },
    medium: {
        l: "1 100%",
    },
    large: {
        l: "0 100%",
    },
});
export const ImageWithHeadlineContainer = styled.div `
  position: relative;
  min-height: 20rem;
  overflow: hidden;
  outline: none;

  ${({ size = "l" }) => `flex: ${sizeMap().small[size]};`}

  > .focus-layer {
    content: "";
    box-sizing: border-box;
    position: absolute;
    height: calc(100% - 2px);
    width: calc(100% - 2px);
    top: 1px;
    left: 1px;
    pointer-events: none;
    ${({ theme }) => `border: 1px solid rgb(${theme.colors.transparentBlack}, 0);`}
  }

  & .image-container {
    transition: all 0.25s ease-in-out;
  }

  &:hover {
    & .image-container {
      transform: scale(1.03);
    }
  }

  &:focus {
    > .focus-layer {
      ${({ theme, focused }) => focused
    ? `border 1px solid ${theme.colors.primaryLight};
           outline 1px solid ${theme.colors.primaryLight};`
    : ""}
    }
  }

  &:active {
    & .image-container {
      transform: scale(1.03);
    }
  }

  @media ${({ theme }) => theme.device.medium} {
    height: 21.75rem;
    max-height: 21.75rem;
    ${({ size }) => `flex: ${sizeMap().medium[size]};`}
  }

  @media ${({ theme }) => theme.device.large} {
    ${({ size }) => `flex: ${sizeMap().large[size]};`}
  }
`;
export const ImageContainer = styled.div `
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
export const ImageWrapper = styled.div `
  width: 100%;
  height: 100%;
  background-color: black;
  ${({ imageSource: image, fallbackImg }) => `background: url(${image}) ${fallbackImg ? `, url(${fallbackImg})` : ""};`}
  ${({ imageStyles }) => `background-size: ${imageStyles.size};`}
  ${({ imageStyles }) => `background-repeat: ${imageStyles.repeat ? "repeat" : "no-repeat"};`}
  ${({ backgroundColor }) => `${backgroundColor ? `background-color: ${backgroundColor}` : ""};`}
  background-position: center center;
`;
export const TitleContainer = styled.div `
  &&& {
    bottom: 2rem;
    left: 0;
    display: flex;
    flex-direction: column;
    font-size: 20px;
    text-transform: uppercase;
    ${({ theme }) => `color: ${theme.colors.white};`}
    box-sizing: border-box;
    padding: 1.5rem;
    padding-top: ${({ withButton }) => (withButton ? "1rem" : "0.5rem")};
    padding-bottom: ${({ withButton }) => (withButton ? "1.5rem" : "0.5rem")};
    min-width: 33.33%;
    width: 100%;

    ${({ theme, backgroundType }) => backdropBlurFilter(4, backgroundType === "light"
    ? theme.colors.transparentWhite
    : backgroundType === "black"
        ? theme.colors.transparentBlack
        : theme.colors.transparentBlack, backgroundType === "white" ? 0.8 : 0.7, backgroundType === "white" ? 0.9 : 0.8)};
    position: absolute;

    h3 {
      z-index: 1;
    }

    button,
    a {
      margin-top: 1.5rem;
      align-self: flex-end;
      z-index: 1;
    }

    @media ${({ theme }) => theme.device.medium} {
      bottom: 3rem;
      padding: 2rem;
      padding-top: ${({ withButton }) => (withButton ? "2rem;" : "1rem")};
      padding-bottom: ${({ withButton }) => (withButton ? "2rem;" : "1rem")};
      width: auto;
      max-width: 66.66%;

      button {
        margin-top: 2.25rem;
      }
    }
  }
`;
